import ResponseStatus from "../ResponseStatus";
export default ResponseStatus;
